import { render, staticRenderFns } from "./ClientMenu.vue?vue&type=template&id=11a0b50a&scoped=true&"
import script from "./ClientMenu.vue?vue&type=script&lang=js&"
export * from "./ClientMenu.vue?vue&type=script&lang=js&"
import style0 from "./ClientMenu.vue?vue&type=style&index=0&id=11a0b50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a0b50a",
  null
  
)

export default component.exports